import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import useStore from './store/useStore';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ChatPage from './pages/ChatPage';
import AdminPage from './pages/AdminPage';
import TodoPage from './pages/TodoPage';
import MeetPage from './pages/MeetPage';
import ProfileSetupPage from './pages/ProfileSetupPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import AnnouncementsPage from './pages/AnnouncementsPage';
import CalendarPage from './pages/CalendarPage';
import NotesPage from './pages/NotesPage';

const PrivateRoute = ({ children }) => {
  const { token } = useStore();
  return token ? children : <Navigate to="/login" />;
};

const PublicRoute = ({ children }) => {
  const { token } = useStore();
  return !token ? children : <Navigate to="/chat" />;
};

function App() {
  const { darkMode } = useStore();

  useEffect(() => {
    if (darkMode) document.documentElement.classList.add('dark');
    else document.documentElement.classList.remove('dark');
  }, [darkMode]);

  // Prevent browser quick-find and other shortcuts interfering with app
  useEffect(() => {
    const handleKey = (e) => {
      const tag = e.target.tagName;
      const isTyping = tag === 'INPUT' || tag === 'TEXTAREA' || e.target.isContentEditable;
      // Block ?, /, F3 from triggering browser find bar when not in input
      if (!isTyping && (e.key === '?' || (e.key === '/' && !e.ctrlKey && !e.metaKey))) {
        e.preventDefault();
        e.stopPropagation();
      }
    };
    document.addEventListener('keydown', handleKey, true); // capture phase
    return () => document.removeEventListener('keydown', handleKey, true);
  }, []);

  return (
    <div className={darkMode ? 'dark' : ''}>
      <BrowserRouter>
        <Routes>
          <Route path="/login"    element={<PublicRoute><LoginPage /></PublicRoute>}/>
          <Route path="/register" element={<PublicRoute><RegisterPage /></PublicRoute>}/>
          <Route path="/forgot-password" element={<PublicRoute><ForgotPasswordPage /></PublicRoute>}/>
          <Route path="/profile-setup" element={<PrivateRoute><ProfileSetupPage /></PrivateRoute>}/>
          <Route path="/setup-profile" element={<PrivateRoute><ProfileSetupPage /></PrivateRoute>}/>
          <Route path="/chat"     element={<PrivateRoute><ChatPage /></PrivateRoute>}/>
          <Route path="/todos"    element={<PrivateRoute><TodoPage /></PrivateRoute>}/>
          <Route path="/announcements" element={<PrivateRoute><AnnouncementsPage /></PrivateRoute>}/>
          <Route path="/calendar" element={<PrivateRoute><CalendarPage /></PrivateRoute>}/>
          <Route path="/notes" element={<PrivateRoute><NotesPage /></PrivateRoute>}/>
          <Route path="/admin"    element={<PrivateRoute><AdminPage /></PrivateRoute>}/>
          <Route path="/meet/:meetId" element={<MeetPage />}/>
          <Route path="/"         element={<Navigate to="/chat" />}/>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right"
        toastOptions={{
          duration: 3000,
          style: { background: darkMode ? '#1e293b' : '#fff', color: darkMode ? '#fff' : '#000' }
        }}/>
    </div>
  );
}

export default App;
